var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"amx-form-field",attrs:{"data-external":"amx-form-field"}},[_vm._t("default"),_vm._v(" "),(_vm.validationError)?_c('div',{staticClass:"validation-error"},[_vm._v(_vm._s(_vm.validationError))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }